import { useDatasets } from "../context/DatasetContext";
import DonorMap from "../components/DonorMap";

export default function MapPage() {
  const { debouncedSelectedIds } = useDatasets();
  return <DonorMap datasetIds={debouncedSelectedIds} />;
}
